import React from 'react'

export interface SSMProductInfo {
  sku: string
  sizes: string[]
  inStockSizes: string[]
  selectedOptions?: { [optionKey: string]: string } | null
}

export const ShoeSizeMeLoaderScript = ({
  shoeSizeMeId,
  defaultLocale,
  source,
}) => {
  const locale = defaultLocale?.split('_')[0] || 'en'

  if (source === 'PDP') {
    return (
      <script
        src="https://shoesize.me/assets/plugin/loader.js"
        dangerouslySetInnerHTML={{
          __html: `
      {
        shopID: "${shoeSizeMeId}",
        locale: "${locale}",
        scale: "uk",
        kids: "true",
        targetGender: "male",
        inCart: function(data) {window.setCartData(data);}
      }
    `,
        }}
      />
    )
  }

  return (
    <script
      src="https://shoesize.me/assets/plugin/loader.js"
      dangerouslySetInnerHTML={{
        __html: `
    {
      shopID: "${shoeSizeMeId}",
      locale: "${locale}",
      scale: "uk",
      kids: "true",
      targetGender: "male",
      action: false
    }
  `,
      }}
    />
  )
}
